<template>
    <div>
        <card-header title="Contacts" icon="fa-address-book"/>

        <card-body>
            <card-toolbar>
                <button @click="$openCard('new-contact', {}, card)"><i class="fas fa-plus mr-2"/>New Contact</button>
            </card-toolbar>
            <card-list>
                <search-list-item @action="searchContacts"/>

                <!-- The directory drills down: type -> company -> contact,
                     each a card to the right. Every type is listed, filled
                     or not, so staff can see the shape of the vocabulary and
                     add to an empty one from its own card. -->
                <subheader-list-item title="Directory" icon="fa-address-book" :badge="totalContacts"/>
                <navigation-list-item
                    v-for="t in types"
                    :key="t.value"
                    :icon="t.icon"
                    :title="t.label"
                    :subtitle="typeSubtitle(t)"
                    :badge="t.contact_count"
                    :active="child && child.definition.component === 'contact-type' && child.props.type === t.value"
                    @click="$openCard('contact-type', {type: t.value}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import SearchListItem from "../../TIER/components/SearchListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import {client as http} from "@/http_client";
    import {TYPES} from "@/components/contact_meta";

    /**
     * The contact directory -- the "Inventory of restaurants and tennis
     * contacts". A peer of Customers and Leads rather than a settings table,
     * because staff browse it.
     */
    export default {
        name: "Contacts",
        props: ['card', 'child'],
        components: {
            NavigationListItem, SubheaderListItem, CardToolbar,
            CardBody, SearchListItem, CardList, CardHeader
        },
        data: function () {
            return {
                // The vocabulary, each entry carrying the server's counts.
                types: TYPES.map(t => ({...t, contact_count: 0, company_count: 0}))
            };
        },
        computed: {
            totalContacts: function () {
                return this.types.reduce((n, t) => n + t.contact_count, 0);
            }
        },
        methods: {
            loadTypes(force) {
                this.$emit('loading', true);
                http.get('/api/contacts/types', {force}).then(response => {
                    const counts = {};
                    (response.data || []).forEach(row => { counts[row.type] = row; });
                    this.types = TYPES.map(t => ({
                        ...t,
                        contact_count: counts[t.value] ? counts[t.value].contact_count : 0,
                        company_count: counts[t.value] ? counts[t.value].company_count : 0
                    }));
                    this.$emit('loading', false);
                });
            },
            typeSubtitle(t) {
                if (!t.contact_count) return 'No contacts yet';
                if (!t.company_count) return 'Individuals only';
                return t.company_count + (t.company_count === 1 ? ' company' : ' companies');
            },
            searchContacts: function (q) {
                this.$openCard('search-contacts', {query: q}, this.card);
            },
            reload: function () {
                this.loadTypes(true);
            }
        },
        mounted() {
            this.loadTypes();
        }
    };
</script>
